export default "__VITE_ASSET__ee1e5e59__"